import script from "./Pagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pagination.vue?vue&type=script&lang=ts&setup=true"

import "./Pagination.vue?vue&type=style&index=0&id=dfd83b5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd83b5a"]])

export default __exports__